import Pusher from 'pusher-js';

// ensure single pusher connection is used across the app
const pusher = new Pusher(window.___editorData.user.pusher.key, {
  encrypted: true
});

export default pusher;
